import { render, staticRenderFns } from "./phone_code.vue?vue&type=template&id=563ae288"
import script from "./phone_code.js?vue&type=script&lang=js&external"
export * from "./phone_code.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports